import View from './view';
export const IconLink = View;
